import {
  buildFiltersUrl,
  reshape_response,
} from "../../../../helpers/functions";
import { examenApi } from "../view/examen.service";

export const getExamenes = examenApi.injectEndpoints({
  endpoints: (builder) => ({
    getExamenes: builder.query({
      query: ({ filter_params }) => ({
        url: buildFiltersUrl(`/v1/api/examenentidad/`, filter_params),
        method: "GET",
      }),
      providesTags: (result) =>
        Array.isArray(result)
          ? [
              ...result.map(({ id }) => ({
                type: "Examenes",
                id,
              })),
              { type: "Examenes", id: "LIST" },
            ]
          : [{ type: "Examenes", id: "LIST" }],
      transformResponse: (response, meta, args) => {
        if (Array.isArray(response)) {
          return response?.map((el) => reshape_response(el, args.shape));
        } else {
          const resultsTransformed = response?.results?.map((el) =>
            reshape_response(el, args.shape)
          );
          return {
            results: resultsTransformed,
            count: response.count,
            next: response.next,
            previous: response.previous,
          };
        }
      },
    }),
  }),
});

export const { useGetExamenesQuery, useLazyGetExamenesQuery } = getExamenes;
